import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";
import { useParams } from "react-router-dom";

export const GalleryDetailsPage = () => {
  const { galid } = useParams();
  const { title } = useParams();
  const [GalleryDetails, setGalleryDetails] = useState([]);
  const [BreadcrumList, setBreadcrumList] = useState([]);
  const fetchBreadcrumImageData = async () => {
    try {
      const response = await corefetch(
        `Breadcrum/GetBreadcrumDetailsByCategory?CategoryCode=GALLERY`
      );
      if (response && response.length > 0) {
        console.log("Breadcrum:", response);
        setBreadcrumList(response);
      } else {
        setBreadcrumList([]);
        console.log("No Breadcrum found");
      }
    } catch (error) {
      console.error("Error fetching Breadcrum List:", error);
      setBreadcrumList([]);
    }
  };

  useEffect(() => {
    fetchBreadcrumImageData();
  }, []);

  const backgroundImageStyle = BreadcrumList[0]
    ? {
        backgroundImage: `url(${ImageURL}${BreadcrumList[0].imagePath})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {};

  const fetchData = async () => {
    try {
      const list = await corefetch(
        `Gallery/GetGalleyImagesDetails?id=${galid}`
      );
      if (list && list.length > 0) {
        setGalleryDetails(list);
      } else {
        setGalleryDetails([]);
      }
    } catch (error) {
      setGalleryDetails([]);
      console.error("Error fetching list:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [galid]);

  useEffect(() => {
    if (GalleryDetails && GalleryDetails.length) {
      setTimeout(function () {
        if ($(".fancybox").length) {
          $(".fancybox").fancybox({
            openEffect: "elastic",
            closeEffect: "elastic",
            wrapCSS: "project-fancybox-title-style",
          });
        }
      }, 300);
    }
  }, [JSON.stringify(GalleryDetails)]);

  return (
    <>
      <section className="wpo-page-title" style={backgroundImageStyle}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div className="wpo-breadcumb-wrap">
                <h2>Gallery</h2>
                <ol className="wpo-breadcumb-wrap">
                  <li>
                    <a href="/home">Home</a>
                  </li>
                  <li>Gallery</li>
                </ol>
              </div>
            </div>
          </div>{" "}
        </div>{" "}
      </section>
      <section
        className="wpo-portfolio-section-s2 pb-0 section-padding gallery"
        id="gallery"
      >
        <div className="container">
          <div className="wpo-section-title">
            <h4>Moments of Brilliance</h4>
            <h2>{title}</h2>
          </div>

          <div className="sortable-gallery">
            <div className="gallery-filters" />
            <div
              className="row"
              style={{
                rowGap: "30px",
                justifyContent: "center",
              }}
            >
              {GalleryDetails.map((image, index) => (
                <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
                  <div
                    className="card"
                    key={image.imageID}
                    style={{
                      overflow: "hidden",
                      borderRadius: "10px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      position: "relative",
                    }}
                  >
                    <div
                      className="img-holder"
                      style={{
                        position: "relative",
                      }}
                    >
                      <a
                        href={`${ImageURL}${image.imagePath}`}
                        className="fancybox"
                        data-fancybox-group="gall-1"
                        style={{
                          display: "block",
                          position: "relative",
                        }}
                      >
                        {/* Image */}
                        <img
                          src={`${ImageURL}${image.imagePath}`}
                          alt=""
                          className="img img-responsive"
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "cover",
                            transition: "transform 0.3s ease",
                          }}
                        />
                        {/* Overlay */}
                        {/* <div
                          className="hover-overlay"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(255, 255, 255, 0)",
                            opacity: 0,
                            transition:
                              "opacity 0.3s ease, background-color 0.3s ease",
                          }}
                        ></div> */}
                        {/* Plus Icon */}
                        <div className="hover-content">
                          <i className="ti-plus"></i>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
